export default __webpack_public_path__ + "node_modules/material-design-iconic-font/dist/fonts/Material-Design-Iconic-Font.woff";